import { TimestampTools } from "@cervval.js/common/tools";
import { MenuDefinition } from "./menu/menuDefinition";
import { PageDefinition } from "./navigation.service";

/**
 * adds or updates ?version=targetVersion in the url
 */
export function generateHrefWithVersion(href: string, version: string | number): string {
    if (href.indexOf("version=") < 0) {
        // there is no version in the url => add it
        const str = (href.indexOf("?") < 0 ? "?" : "&") + "version=" + version;
        // if there was a hash inside the url => place it after the version
        const hashIndex = href.lastIndexOf("#");
        if (hashIndex === -1) {
            href += str;
        } else {
            href = href.slice(0, hashIndex) + str + href.slice(hashIndex);
        }
    } else {

        // there is already a version in the url => replace it
        const versionIndex = href.lastIndexOf("version=");
        const ampersandIndex = href.indexOf("&", versionIndex + 1);
        const hashIndex = href.indexOf("#", versionIndex + 1);
        let index = ampersandIndex;
        if (hashIndex >= 0) {
            if (index < 0 || index > hashIndex) {
                index = hashIndex;
            }
        }
        if (index >= 0) {
            // version is before a & or a #
            href = href.substring(0, versionIndex) + "version=" + version + href.substring(index);
        } else {
            // version is the last part of the url
            href = href.substring(0, versionIndex) + "version=" + version;
        }
    }
    return href;
}

/** generate a href from provided href, removes the hash and adds ?reload=timestamp*/
export function generateHrefWithReload(href: string, ts: TimestampTools.UnixTimestamp): string {
    let result = href;
    if (href.indexOf("#") > -1) {
        result = href.substring(0, href.indexOf("#"));// remove hash
    }
    if (href.indexOf("?") > -1) {
        result = result.substring(0, result.indexOf("?"));// remove query
    }
    result = result + "?reload=" + ts;
    return result;
}

/** @returns true if element is a menuDefinition */
export function isMenuDefinition(element : MenuDefinition | PageDefinition): element is MenuDefinition {
    return (element as PageDefinition).importPromise === undefined;
}